import { render, staticRenderFns } from "./DwzxbgsqEdit.vue?vue&type=template&id=b03fac7c"
import script from "./DwzxbgsqEdit.vue?vue&type=script&lang=js"
export * from "./DwzxbgsqEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports